export const DEFAULT_BRANDING = { tagline: "Construction & renovation management", logo_url: null, hero_image_url: null, primary_color: "#1d483a", accent_color: "#b1492f", email_sender_name: "", surface: "grey" };
export const PLATFORM = { name: "E.L.M", slug: null, branding: DEFAULT_BRANDING, white_label: false, platform: true };

export const SURFACES = {
  grey: { label: "Cool grey", swatch: "#eef0f3", vars: { "--background": "216 14% 95%", "--card": "0 0% 100%", "--secondary": "216 12% 91%", "--muted": "216 12% 92%", "--border": "216 12% 86%", "--input": "216 12% 82%", "--foreground": "218 22% 12%", "--muted-foreground": "218 10% 40%" } },
  stone: { label: "Warm stone", swatch: "#eceae6", vars: { "--background": "36 12% 93%", "--card": "40 20% 99%", "--secondary": "36 10% 89%", "--muted": "36 10% 90%", "--border": "36 10% 84%", "--input": "36 10% 80%", "--foreground": "30 14% 12%", "--muted-foreground": "30 8% 40%" } },
  white: { label: "Soft white", swatch: "#fafafa", vars: { "--background": "0 0% 99%", "--card": "0 0% 100%", "--secondary": "220 10% 94%", "--muted": "220 10% 95%", "--border": "220 10% 88%", "--input": "220 10% 84%", "--foreground": "220 20% 12%", "--muted-foreground": "220 8% 42%" } },
  dark: { label: "Slate", swatch: "#1f242b", vars: { "--background": "215 18% 13%", "--card": "215 16% 17%", "--secondary": "215 14% 22%", "--muted": "215 14% 21%", "--border": "215 12% 26%", "--input": "215 12% 28%", "--foreground": "216 14% 92%", "--muted-foreground": "216 10% 66%", "--popover": "215 16% 17%", "--popover-foreground": "216 14% 92%", "--card-foreground": "216 14% 92%", "--secondary-foreground": "216 14% 90%" } },
};

function applySurface(key) {
  const root = document.documentElement.style;
  const all = new Set(Object.values(SURFACES).flatMap((s) => Object.keys(s.vars)));
  all.forEach((k) => root.removeProperty(k));
  const s = SURFACES[key];
  if (s && key !== "grey") Object.entries(s.vars).forEach(([k, v]) => root.setProperty(k, v));
  document.documentElement.classList.toggle("surface-dark", key === "dark");
}

export function hexToHsl(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return [0, 0, l * 100];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return [h * 60, s * 100, l * 100];
}

const css = ([h, s, l]) => `${h.toFixed(0)} ${s.toFixed(0)}% ${l.toFixed(0)}%`;

export function applyBranding(branding) {
  const root = document.documentElement.style;
  const p = hexToHsl(branding?.primary_color) || hexToHsl(DEFAULT_BRANDING.primary_color);
  const a = hexToHsl(branding?.accent_color) || hexToHsl(DEFAULT_BRANDING.accent_color);
  root.setProperty("--brand-primary", css(p));
  root.setProperty("--brand-primary-fg", p[2] > 60 ? "200 25% 12%" : "40 33% 96%");
  root.setProperty("--brand-accent", css(a));
  root.setProperty("--spruce", css([p[0], Math.min(p[1] + 2, 100), Math.max(Math.min(p[2] * 0.65, 16), 7)]));
  applySurface(branding?.surface || "grey");
}

export function brandingFromHost() {
  const params = new URLSearchParams(window.location.search);
  return { slug: params.get("ws") || sessionStorage.getItem("elm_ws") || undefined, host: window.location.hostname };
}

export const readable = (hex) => ((hexToHsl(hex) || [0, 0, 50])[2] > 60 ? "#1b1b1b" : "#ffffff");
